/**
 * Basic
 */
export const ENV = {
    BASE_URL: process.env.BASE_URL ?? 'http://localhost:3000',
    GAPI_CLIENT_ID: process.env.GAPI_CLIENT_ID ?? '',
    VAPID_PUBLIC_KEY: process.env.VAPID_PUBLIC_KEY ?? '',
    SENTRY_DSN: process.env.SENTRY_DSN ?? '',
};
/**
 * Styling
 */
export const BORDER_RADIUS = 8;
export const WIDTH_NARROW = 350;
export const WIDTH_PHONE_SMALL = 576;
export const WIDTH_PHONE = 785;
export const HEIGHT_TYPING = 500;
export const MAX_WIDTH = 780;
export const STAGE_POMODORO = 'pomodoro';
export const STAGE_SHORT = 'short';
export const STAGE_LONG = 'long';
/**
 * Shadows
 */
export const SHADOW_1 = '0 1.5px 4px 0 rgba(0,0,0,0.04), 0 0.5px 1.5px 0 rgba(0,0,0,0.06)';
export const SHADOW_2 = '0 2px 8px 0 rgba(0,0,0,0.06), 0 1px 3px 0 rgba(0,0,0,0.08)';
export const SHADOW_3 = '0 4px 16px 0 rgba(0,0,0,0.08), 0 2px 6px 0 rgba(0,0,0,0.10)';
export const SHADOW_4 = '0 8px 24px 0 rgba(0,0,0,0.10), 0 4px 12px 0 rgba(0,0,0,0.12)';
export const SHADOW_5 = '0 12px 32px 0 rgba(0,0,0,0.12), 0 6px 16px 0 rgba(0,0,0,0.14)';
export const COOKIE_ACCESS_TOKEN = 'access_token';
export const NOTIFICATION_POPUP_SHOWN = 'notification_popup_shown';
/**
 * Report Type
 */
export const REPORT_TYPE_DAY = 'day';
export const REPORT_TYPE_WEEK = 'week';
export const REPORT_TYPE_YEAR = 'year';
/**
 * Notification
 */
export const NT_EVERY = 'every';
export const NT_LAST = 'last';
export const NT_SELECTIONS = [
    { id: NT_EVERY, text: 'Every' },
    { id: NT_LAST, text: 'Last' },
];
export const WP_ENABLED = 'enabeld';
export const WP_DISABLED = 'disabled';
export const WEB_PUSH_SELECTIONS = [
    { id: WP_ENABLED, text: 'Enabled' },
    { id: WP_DISABLED, text: 'Disabled' },
];
/**
 * Colors
 */
export const COLOR_LIGHTGRAY = 'hsl(0, 0%, 94%)';
export const COLOR_GRAY_1 = 'hsl(0, 0%, 92%)';
export const COLOR_GRAY_2 = 'hsl(0, 0%, 83%)';
export const COLOR_GRAY_3 = 'hsl(0, 0%, 77%)';
export const COLOR_GRAY_4 = 'hsl(0, 0%, 67%)';
export const COLOR_GRAY_5 = 'hsl(0, 0%, 57%)';
export const COLOR_GRAY_6 = 'hsl(0, 0%, 47%)';
export const COLOR_GRAY_7 = 'hsl(0, 0%, 37%)';
export const COLOR_GRAY_8 = 'hsl(0, 0%, 27%)';
export const COLOR_GRAY_9 = 'hsl(0, 0%, 17%)';
export const COLOR_GRAY_0 = 'hsl(0, 0%, 07%)';
/**
 * DELIMITER
 */
export const DELIMITER_COMMA = 'comma';
export const DELIMITER_TAB = 'tab';
/**
 * Notification
 */
export const HOUR_FORMAT_24 = '24-hour';
export const HOUR_FORMAT_12 = '12-hour';
export const HOUR_FORMAT_SELECTION = [
    { id: HOUR_FORMAT_24, text: '24-hour' },
    { id: HOUR_FORMAT_12, text: '12-hour' },
];
export const WEEK_START_MONDAY = 'monday';
export const WEEK_START_SATURDAY = 'saturday';
export const WEEK_START_SUNDAY = 'sunday';
export const WEEK_START_SELECTION = [
    { id: WEEK_START_MONDAY, text: 'Monday' },
    { id: WEEK_START_SATURDAY, text: 'Saturday' },
    { id: WEEK_START_SUNDAY, text: 'Sunday' },
];
/**
 * TodoList Apps
 */
export const TODO_APP_TODOIST = 'Todoist';
const TODOIST_CLIENT_ID = '3ac978dcf65c471da2dbd3ac10b222cc';
export const TODOIST_AUTH_URL = `https://todoist.com/oauth/authorize?client_id=${TODOIST_CLIENT_ID}&scope=data:read_write&state=`;
/**
 * Keyboard
 */
// export const KEY_DOWN = 40;
// export const KEY_UP = 38;
// export const KEY_ENTER = 13;
/**
 * WebPush
 */
export const WEBPUSH_TYPE_POMODORO = 'pomodoro';
export const WEBPUSH_TYPE_BREAK = 'break';
export const WEBPUSH_TYPE_BOTH = 'both';
export const WEBPUSH_TYPE_NONE = 'none';
export const WEBPUSH_TYPE_SELECTIONS = [
    { id: WEBPUSH_TYPE_POMODORO, text: 'Pomodoro' },
    { id: WEBPUSH_TYPE_BREAK, text: 'Break' },
    { id: WEBPUSH_TYPE_BOTH, text: 'Both' },
    { id: WEBPUSH_TYPE_NONE, text: 'None' },
];
/**
 * Keys
 */
// 13
export const KEY_ENTER = 'Enter';
// 27
export const KEY_ESCAPE = 'Escape';
// 73
export const KEY_I = 'i';
// 85
export const KEY_D = 'd';
// 74
export const KEY_P = 'p';
// 78
export const KEY_N = 'n';
export const KEY_T = 't';
export const KEY_UP = 'ArrowUp';
export const KEY_DOWN = 'ArrowDown';
export const KEY_SPACE = ' ';
/**
 * Element IDs
 */
export const STAGE_BUTTON_POMODORO = 'stage-button-pomodoro';
